export const blockIconsTravelElevatorNew = (
	<span className='material-symbols-outlined'>elevator</span>
);
